

































# import settings from '@/settings'
import t from '@/utils/tools'

export default {
    name: 'qualities'

    props: ['payload', 'deletions']

    watch:
        payload: (new_item, old_item)->
            # console.log "WATCH ", new_item, old_item
            if Object.keys(@payload).length == 0
                @add_quality()

    data: ()->
        min: 0
        max: 10
        false: false
        quality: {
            uid: ''
            name: ''
            skill_type: 'quality'
            slug: ''
            level_waited: 5
            mandatory: false
        }

    methods:
        deep_copy: t.deep_copy

        remove_quality: (index)->
            if @payload[index]['uid'] != ""
                @deletions.push(@payload[index]['uid'])
            # console.log "DELETIONS Q : ", @deletions
            if Object.keys(@payload).length > 1
                @payload.splice(index, 1)
            else
                @payload[0].name = ""
                @payload[0].level_waited = 1
                # console.log "FIRST QUALITY"

        add_quality: ()->
            @payload.push(@deep_copy(@quality))
        
    beforeMount: ()->
        # console.log "QUALITIES COMPONENT : ", @payload
        if Object.keys(@payload).length == 0
            @add_quality()

}

